"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgSneakerOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M3.97 10.477v5.24c0 .439.355.794.794.794h13.608a1.597 1.597 0 00.507-3.111l-7.205-2.41-.101-.008a5.022 5.022 0 01-3.355 1.274 5.028 5.028 0 01-3.815-1.748.205.205 0 00-.034-.031h-.4zm-2-.103c0-1.048.849-1.897 1.897-1.897h.527c.648 0 1.181.329 1.523.725a3.029 3.029 0 002.301 1.054c.768 0 1.467-.283 2.002-.753.365-.32.887-.563 1.485-.516l.37.028 7.438 2.488a3.597 3.597 0 01-1.14 7.008H4.763a2.795 2.795 0 01-2.795-2.794v-5.343z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M1.94 14.998v-1.996C1.96 13 1.98 13 2 13h3.358a5 5 0 013.8 1.75l2.755 3.221H9.281L7.638 16.05A3 3 0 005.358 15H2c-.02 0-.04 0-.06-.002zm14.904-3.73l1.935.648-1.491 2.584a1 1 0 01-1.733-1l1.289-2.231zm-1.094-.365l-1.936-.648-1.334 2.31a1 1 0 001.732 1l1.538-2.662z' }))); };
exports.default = SvgSneakerOutline;
//# sourceMappingURL=SneakerOutline.js.map